import { render, staticRenderFns } from "./ProductCounterOffersPanel.vue?vue&type=template&id=31c3b792&scoped=true"
import script from "./ProductCounterOffersPanel.vue?vue&type=script&lang=js"
export * from "./ProductCounterOffersPanel.vue?vue&type=script&lang=js"
import style0 from "./ProductCounterOffersPanel.vue?vue&type=style&index=0&id=31c3b792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c3b792",
  null
  
)

export default component.exports